module.exports = __webpack_public_path__ + "static/media/bo.4128202a.svg";